<template>
  <div class="sp" style="position: relative">
    <div
      style="width: 1200px; margin: 0 auto; padding: 10px 0"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>
    <div class="detailss" style="min-height: 75vh; background: white">
      <div class="flexss" style="width: 1200px; margin: 0 auto; display: flex">
        <div class="productLeft">
          <!-- 左侧中图 -->
          <div class="mdImg">
            <img
              v-if="gift_details"
              :src="gift_details.festivalPackage.imageUrl"
              alt
            />
          </div>
          <!-- 遮罩层 -->
          <div
            v-show="isShow"
            class="marks"
            :style="{ top: top + 'px', left: left + 'px' }"
          ></div>
          <!-- 遮罩层 玻璃板 superMarks-->
          <div
            @mouseenter="enter"
            @mouseleave="leave"
            @mousemove="marks"
            class="superMarks"
          ></div>
          <!--左侧小图 -->

          <!-- 左侧大图 -->
          <div v-show="isShow" class="lgImg">
            <img
              v-if="gift_details"
              :src="gift_details.festivalPackage.imageUrl"
              alt
              :style="{ top: topLgImg + 'px', left: leftLgImg + 'px' }"
            />
          </div>
        </div>
        <div class="sp_right">
          <p
            v-if="gift_details"
            style="font-size: 20px; font-weight: 600; margin-bottom: 31px"
          >
            {{ gift_details.festivalPackage.name }}
          </p>
          <div
            class="sale_price"
            style="padding-left: 10px"
            v-if="user && user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid&&!hidetype"
          >
            <span style="color: #5b5d66; letter-spacing: 30px">价格</span>
            <img
              style="
                width: 16px;
                height: 16px;
                background: none;
                margin-left: 20px;
              "
              v-if="
                user.festival.priceSymbol &&
                user.festival.priceSymbol.slice(0, 4) == 'http'
              "
              :src="user.festival.priceSymbol"
            />
            <img
              style="
                width: 16px;
                height: 16px;
                background: none;
                margin-left: 20px;
              "
              v-if="!user.festival.priceSymbol"
              src="../../assets/img/pindou.png"
            />
            <span
              style="font-size: 16px; color: #fd5430; font-weight: 600"
              v-if="gift_details.festivalPackage"
              >{{ gift_details.festivalPackage.standardPrice / 100 }}</span
            >
            <span
              style="
                color: #fd5430;
                font-weight: 600;
                margin-left: 4px;
                font-size: 14px;
              "
              v-if="
                user.festival.priceSymbol &&
                user.festival.priceSymbol.slice(0, 4) != 'http'
              "
              >{{ user.festival.priceSymbol }}</span
            >
            <span
              style="
                font-size: 14px;
                color: #999999;
                margin-left: 16px;
                text-decoration: line-through;
              "
              v-if="
                gift_details.festivalPackage &&
                gift_details.festivalPackage.marketPrice &&
                gift_details.festivalPackage.marketPrice >
                  gift_details.festivalPackage.standardPrice
              "
              >{{ gift_details.festivalPackage.marketPrice / 100 }}</span
            >
            <span
              style="
                font-size: 14px;
                color: #999999;
                margin-left: 16px;
                text-decoration: line-through;
              "
              v-if="
                gift_details.festivalPackage &&
                !gift_details.festivalPackage.marketPrice &&gift_details.festivalPackage.autoRefreshPrice&&
                gift_details.festivalPackage.itemPriceTotal >
                  gift_details.festivalPackage.standardPrice
              "
              >{{ gift_details.festivalPackage.itemPriceTotal / 100 }}</span
            >
          </div>
          <div
            class="sale_prices"
            style="padding-left: 10px"
            v-if="
              user &&
              user.festival &&
              user.festival.type == 1 &&
              gift_details.festivalPackage &&
              gift_details.festivalPackage.marketPrice
            "
          >
            <!-- <span style="font-size:14px;color:#ff5c4d;letter-spacing:1px;font-weight:600;margin-right:4px">市场价</span>
            <span style="font-size:16px;color:#ff5c4d;letter-spacing:1px;font-weight:600">{{gift_details.festivalPackage.marketPrice/100}}</span> -->
            <div
              v-html="gift_details.festivalPackage.tag"
              style="max-height: 100px"
            ></div>
          </div>
          <div style="display: flex;align-items: center;background:#FFEBDD;color:#FF461B;height:40px;padding-left:10px" v-if='gift_details.festivalPackage&&gift_details.festivalPackage.description'>
            <img style="height:20px;width:20px;margin-right:10px;" src="../../assets/img/111a.png" alt="">
            <span>{{gift_details.festivalPackage.description}}</span>
          </div>
          <div style="margin-top: 25px; padding-left: 10px">
            <span style="color: #5b5d66; letter-spacing: 2px"  >包裹数量 </span>
            <span style="color: #5b5d66; margin-left:40px " 
              >x{{ packageCount > 0 ? packageCount : all_num }}</span
            >
          </div>
          <div style="margin-top: 25px; padding-left: 10px">
            <span style="color: #5b5d66; letter-spacing: 30px">状态</span>
            <span
              style="color: #cccccc; margin-left: 20px"
              class="ydh"
              v-if="gift_details.offSale"
              >已售罄</span
            >
            <span
              style="margin-left: 20px; color: #cccccc"
              class="ydh"
              v-if="
                (gift_details.offSale == false) &
                (gift_details.stockOut == true)
              "
              >{{gift_details.festivalPackage&&gift_details.festivalPackage.stockOutDesc?gift_details.festivalPackage.stockOutDesc:'补货中'}}</span
            >
            <span
              style="margin-left: 20px; color: #5b5d66"
              class="ydh"
              v-if="
                (gift_details.offSale == false) &
                (gift_details.stockOut == false)
              "
              >已上架</span
            >
          </div>
          <div style="margin-top: 25px; padding-left: 10px">
            <span style="color: #5b5d66; letter-spacing: 8px">配送至</span>
            <span style="margin-left: 43px" v-if="show_address"
              >{{ show_address.province }}{{ show_address.city
              }}{{ show_address.district }}{{ show_address.town
              }}{{ show_address.detail }}</span
            ><span
              v-if="!show_address"
              style="margin-left: 42px; color: #3395f5; cursor: pointer"
              @click="bindshowaddress(2)"
              >请选择收货地址></span
            >
            <span v-if="!address_show" style="color: red"
              >(该地址暂不支持配送，请重新选择)</span
            >
            <p
              style="padding-left: 107px; color: #3395f5; cursor: pointer"
              v-if="show_address"
              @click="bindshowaddress(1)"
            >
              选择其他地址>
            </p>
          </div>
          <div
            style="
              margin-top: 25px;
              padding-left: 10px;
              display: flex;
              align-items: center;
            "
            v-if="gift_details.spuList && gift_details.spuList.length == 1"
          >
            <span style="color: #5b5d66; letter-spacing: 30px">运费</span>
            <div style="margin-left:20px">
              <span
                v-if="
                  (feedetail && feedetail.isall == 2) ||
                  (feedetail &&
                    feedetail.isall == 1 &&
                    gift_details.festivalPackage.standardPrice / 100 >=
                      feedetail.orderfee)
                "
                style="font-size: 28rpx"
                >包邮</span
              >
              <div v-else>
                  <img
                style="
                  width: 16px;
                  height: 16px;
                  background: none;
                "
                v-if="feedetail&&feedetail.postfees"
                src="../../assets/img/pindou.png"
              />
              <span
                style="font-size: 16px; color: #fd5430; font-weight: 600"
                 v-if="feedetail"
                >{{feedetail.postfees}}</span
              >
              </div>
              
            </div>
          </div>
          <div class="aniu">
            <!-- user.festival.id!=$store.state.hidePriceid -->
            <div v-if='user.festival&&user.festival.id!=$store.state.hidePriceid'>
              <span
                class="ljdh"
                v-if="
                  gift_details.offSale == false &&
                  gift_details.stockOut == false &&
                  address_show
                "
                @click="binddh"
                >立即兑换</span
              >
              <span class="ljdh" v-else style="opacity: 0.5">立即兑换</span>
            </div>
            
            <!-- <div v-if="user.festival && user.festival.type == 2"> -->
            <div>
              <span
                class="ljdh"
                style="margin-left: 10px; background: #f96a3e"
                v-if="
                  (gift_details.offSale == false) &
                  (gift_details.stockOut == false)&&address_show
                "
                @click="addcart"
                >加入购物车</span
              >
              <span
                class="ljdh"
                v-else
                style="opacity: 0.5; margin-left: 10px; background: #f96a3e"
                >加入购物车</span
              >
            </div>

            <span class="ljdhs" @click="tpVisible = true">兑换须知</span>
          </div>
        </div>
      </div>
      <div class="detail_bottom">
        <div class="d_b_left">
          <h5>套餐商品</h5>
          <div class="smImg">
            <!--左按钮 -->
            <div @click="prev" class="button-prev">
              <img
                style="margin-top: 6px; border: none; width: 32px; height: 32px"
                src="../../assets/img/icon-xiangzuo.png"
              />
            </div>
            <div class="smImgUl">
              <ul :style="{ 'margin-left': marginLeft + 'px' }">
                <li
                  @mouseenter="enterLi(index)"
                  v-for="(item, index) in gift_details.spuList"
                  :key="item.uid"
                >
                  <img
                    :class="d_index == index ? 'd_index' : ''"
                    :src="item.baseImage"
                    alt
                  />
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
            <!-- 右按钮 -->
            <div @click="next" class="button-next">
              <img
                style="margin-top: 6px; border: none; width: 32px; height: 32px"
                src="../../assets/img/icon-xiangyou.png"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="detail_bottom">
        <div class="d_b_left">
          <h5>商品详情</h5>
          <div
            style="
              width: 100%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span></span>
            <div
              v-if="sp_details.itemDetail"
              class="fwb"
              v-html="sp_details.itemDetail.detail"
            ></div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="page-up" @click="scrollToTop" v-show="toTopShow">
      <img src="../../assets/img/icon-Top.png" />
    </div>

    <el-dialog
      title="选择收货地址"
      :visible.sync="addressVisible"
      width="620px"
      @close='bindclose'
      center
    >
      <address_box
        :type="false"
        ref="adbox"
        @bindselects="bindselects"
        @bindqqxs="bindqqxs"
      ></address_box>
    </el-dialog>
    <el-dialog title="兑换须知" :visible.sync="tpVisible" width="640px" center>
      <div
        style="height: 350px; max-height: 550px; overflow: auto"
        v-if="
          gift_details.spuList && gift_details.spuList[0].itemDetail.goodsArea
        "
      >
        <div>{{ gift_details.spuList[0].itemDetail.goodsArea }}</div>
      </div>
      <div style="height: 350px; max-height: 550px; overflow: auto" v-else v-html='AfterSale'>
        <!-- {{AfterSale}} -->
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button style="height：42px;width:144px;" @click="tpVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="选择商品规格"
      :visible.sync="tpVisibless"
      width="640px"
      center
    >
      <div style="min-height: 300px; max-height: 600px; overflow: auto">
        <div
          class="gg_box"
          v-for="(item, indexss) in gift_details.spuList"
          :key="indexss"
        >
          <div style="display: flex">
            <img
              style="height: 80px; width: 80px; margin-right: 10px"
              :src="
                currentSkuData[item.id] ? currentSkuData[item.id].baseImage : item.baseImage
              "
              alt
            />
            <div>
              <p style="margin-top: 34px">
                {{
                  currentSkuData[item.id]
                    ? currentSkuData[item.id].itemAttrValue
                    : item.name
                }}
              </p>
              <p>数量：{{ gift_details.spuNoList[indexss] }}</p>
            </div>
          </div>
          <div class="gbox" v-for="(item1, indexs) in item.attr" :key="indexs">
            <span class="titles">{{ item1.attr_name }}</span>
            <div style="flex: 1">
              <span
                class="g_li"
                @click="bindchanrgegg(indexss, indexs, index)"
                :class="
                  index == item1.index
                    ? 'g_active'
                    : item2.show
                    ? ''
                    : 'no_show'
                "
                v-for="(item2, index) in item1.options"
                :key="index"
                >{{ item2.option_name }}</span
              >
            </div>
          </div>
          <div v-for="(item1, indexs) in item.subGoodss" :key="item1.id">
            <div class="gbox" v-if="item1.sub_goods.length > 0">
              <span class="titles">{{ item1.attr_name }}</span>
              <div style="flex: 1">
                <span
                  class="g_li"
                  @click="bindchanrfgg(indexss, indexs, index)"
                  :class="
                    index == item1.indexx
                      ? 'g_active'
                      : item2.show
                      ? ''
                      : 'no_show'
                  "
                  v-for="(item2, index) in item1.sub_goods"
                  :key="index"
                  >{{ item2.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <div
          v-if="show_text || dq_kc_text||show_text1"
          style="color: rgb(252, 67, 67); margin-bottom: 10px"
        >
          <!-- <span v-if="show_text">{{ show_text }}已下架</span
          ><span v-if="show_text && dq_kc_text">，</span
          ><span v-if="dq_kc_text">{{ dq_kc_text }}所选规格暂无库存</span> -->
          <span v-if='show_text || dq_kc_text'>{{show_text?show_text+'已下架':dq_kc_text+'所选规格暂无库存'}}</span>
          <span v-else>所选规格已被禁用</span>
          
          <!-- <span>每人 {{item.limitDay}} 天内限购 {{item.limitNum}} 件</span> -->
          
        </div>
        <el-button
          v-if="show_text || dq_kc_text"
          style="height：42px;width:144px;background:#b3b3b3;color:white;border:none"
          >确定</el-button
        >
        <el-button
          v-else
          style="height：42px;width:144px;background:#F3A251;color:white;border:none"
          @click="binddhs"
          >确定</el-button
        >
        <el-button
          style="height：42px;width:144px;"
          @click="tpVisibless = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message, Loading } from "element-ui";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import address_box from "../../components/address_box";
import Vue from "vue";
import $ from "jquery";
import md5 from "js-md5";
export default {
  name: "index",
  components: { address_box },
  data() {
    var vm = this;
    return {
        packageCount: 0,//包裹数量
      all_num: 1,
      number: "",
      password: "",
      tpVisible: false,
      yidong: "",
      left: 0,
      s_show: false,
      sj_time: false,
      jgpx: false,
      zcd_show: false,
      cd_show: false,
      text: "",
      detail_type: true,
      list: [],
      mdImgUrl: "s1.png",
      lgImgUrl: "s1.png",
      ulIndex: 0, //向左移动几个li
      marginLeft: 0, //向左向右移动的距离
      isShow: false, //控制遮罩层marks和大图片是否显示"
      left: 0, //marks左移位置
      top: 0, //marks下移位置
      leftLgImg: 0, //大图lgImg移动的位置
      topLgImg: 0, //大图lgImg移动的位置
      sp_id: this.$route.query.id ? this.$route.query.id : "",
      sp_details: "",
      d_index: 0,
      radio: "",
      num: 1,
      gift_details: "",
      active_img: "../../assets/img/bj.png",
      toTopShow: false,
      gg_index: 0,
      loading: false,
      sp_gd_num: 20,
      sku_detail: "",
      length_show: false,
      length_shows: false,
      text_show: 0,
      gift_id: this.$route.query.id ? this.$route.query.id : "",
      hidetype:this.$route.query.hidetype,
      tpVisibless: false,
      selectedItem: [],
      show_text: "",
      show_text1:'',
      user: "",
      currentSkuData: {},
      cart_show: false,
      show_address: "",
      addressVisible: false,
      dq_kc_text: "",
      yf_price: 0,
      address_show: true,
      feedetail: "",
      getaShow:true,
      AfterSale:''
    };
  },
  created() {},
  mounted() {
    var user = sessionStorage.getItem("user");
    console.log(JSON.parse(user));
    if (user) {
      this.user = JSON.parse(user);
    } else {
      this.$router.push({ path: "/login" });
    }
    this.gift_detail();

    this.$nextTick(function () {
      window.addEventListener("scroll", this.handleScroll, true);
    });
    if(!this.$store.state.balance){
      this.getUser()
    }
    this.querydocumentlists()
  },
  destroyed() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
  	querydocumentlists(){
				var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
          var data = {
            clientPlatform: 1,
            type:'4'
          };
				this.$server.querydoclist(data,headers).then(res => {
					console.log('公告',res)
					if(res.code==0){
						if(res.data&&res.data.default){
							var text1 = res.data.default.find(val=>val.type==4)
							this.AfterSale = text1!=undefined?text1.content:''
						}
					}
				})
			},
    getUser(){
				var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
				this.$server.getCardUserBalance({},headers).then(res => {
					console.log('',res)
					if(res.code==0){
						var user = this.user
						this.$store.state.cardDate = res.data.default.cardDate;
						this.$store.state.validTimes=res.data.default.validTimes
         				this.$store.state.balance = res.data.default.balance;
						sessionStorage.setItem("user",JSON.stringify(user))
					}
				})
			},
    getaddress(type) {
      if(!this.getaShow){
        return
      }
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      var show_address = localStorage.getItem("show_address");
      this.$server.queryaddress({}, headers).then((res) => {
        if (res.code == 0) {
          console.log("dizhi", res);
          var list = res.data.default;
          this.show_address = list[0];
          list.forEach((item, index) => {
            if (item.defaultAddress) {
              this.show_address = item;
            }
          });
          if (type == 1 && show_address&&list.length>0) {
            this.show_address = JSON.parse(show_address);
          }
          if(list.length==0){
            this.show_address = ''
          }
          console.log('this.show_address',this.show_address)
          this.binddq_kc();
          this.binddq_kcs();
          this.qr_address();
        }
      });
    },
    bindclose(){
      this.getaddress()
    },
    bindqqxs(e) {
      console.log("取消");
      this.addressVisible = false;
      
    },
    bindselects(e) {
      this.getaShow = false
      this.addressVisible = false;
      this.show_address = e;
      this.binddq_kc();
      this.binddq_kcs();
      this.qr_address();
      console.log(e);
    },
    bindshowaddress(e) {
      this.addressVisible = true;
      console.log(this.detail_type);
    },
    addcart() {
      this.tpVisibless = true;
      this.cart_show = true;
    },
    bindjj(arrs) {
      arrs = Array.from(arrs);
      var arr = arrs.shift();
      for (var i = arrs.length; i--; ) {
        var p = { boolean: {}, number: {}, string: {} },
          obj = [];
        arr = arr.concat(arrs[i]).filter(function (x) {
          var t = typeof x;
          return !(t in p
            ? !p[t][x] && (p[t][x] = 1)
            : obj.indexOf(x) < 0 && obj.push(x));
        });
        if (!arr.length) return null;
      }
      return arr;
    },
    bindshow(a) {
      var list = this.gift_details;
      // let disableSkuIdList = list.festivalPackage.itemSkuBanned
      //   ? list.festivalPackage.itemSkuBanned.split(",")
      //   : []; //被禁用的sku
      let itemSkuEnableds = list.festivalPackage.itemSkuEnableds//自持的sku
      let selectDisabled = [];
      let selectOnSale = []; //已下架规格
      this.show_text = "";
      this.show_text1 = ''
      var textsss = ''
      var textsss1 = ''
      list.spuList.forEach((item, indexcc) => {
        var arr_lsit = [];
        var show_num = 0;
        let onSaleList = item.itemSkus.filter((val) => val.onSale === false); //筛选已下架规格

        if (onSaleList.length) {
          onSaleList = onSaleList.map((val) => String(val.id));
        }

        item.attr.forEach((item1) => {
          if (item1.attr_name && item1.options && item1.options.length > 0) {
            var lil = item1.options[item1.index].sku_ids;
            lil = Array.from(new Set(lil));
            arr_lsit.push(lil);
          }
        });
        console.log('arr_lsit',this.bindjj(arr_lsit))
        let show_skuid = this.bindjj(arr_lsit);
        // setTimeout(()=>{
        if(show_skuid||item.itemSkus.length==1){
            item.show_skuid = show_skuid ? show_skuid[0] : item.itemSkus[0].id;
        }else{
          selectDisabled.push({
            itemAttrValue:item.name
          })
        }
        
        let skuData = item.itemSkus.find(
          (val) => val.id === Number(item.show_skuid)
        );
        this.$set(this.currentSkuData, item.id, skuData);
        console.log(itemSkuEnableds.includes(Number(item.show_skuid)))
        if (!itemSkuEnableds.includes(Number(item.show_skuid))) {
          let disabledSku = item.itemSkus.find(
            (val) => val.id === Number(item.show_skuid)
          );
          if(disabledSku!=undefined){
            selectDisabled.push(disabledSku);
          }
          
        }
        if (onSaleList.includes(item.show_skuid)) {
          let disabledSku = item.itemSkus.find(
            (val) => val.id === Number(item.show_skuid)
          );
          selectOnSale.push(disabledSku);
        }
        let text1 = item.itemSkus.find(
          (val) => val.id === Number(item.show_skuid)
        );
       if(!textsss){
         textsss = text1 == undefined ? item.name : "";
       }
         console.log(textsss)
        if (a) {
          if (indexcc == a) {
            item.itemSkus.forEach((itemn) => {
              if (itemn.id == item.show_skuid) {
                var subGoodss = itemn.subGoods
                  ? JSON.parse(itemn.subGoods)
                  : [];
                subGoodss.forEach((ittm) => {
                  var array = [];
                  ittm.indexx = 0;
                  ittm.sub_goods.forEach((itemt) => {
                    if (itemt.price == 0) {
                      array.push(itemt);
                    }
                  });
                  ittm.sub_goods = array;
                });
                this.$set(item, "subGoodss", subGoodss);
              }
            });
          }
        } else {
          item.itemSkus.forEach((itemn) => {
            if (itemn.id == item.show_skuid) {
              var subGoodss = itemn.subGoods ? JSON.parse(itemn.subGoods) : [];
              subGoodss.forEach((ittm) => {
                var array = [];
                ittm.indexx = 0;
                ittm.sub_goods.forEach((itemt) => {
                  if (itemt.price == 0) {
                    array.push(itemt);
                  }
                });
                ittm.sub_goods = array;
              });
              this.$set(item, "subGoodss", subGoodss);
            }
          });
        }

        // },200)
      });

      if (selectDisabled.length > 0) {
        console.log("存在被禁用的规格", selectDisabled);
          textsss1 = selectDisabled[0].itemAttrValue;
      } else if (selectOnSale.length > 0) {
        console.log("存在已下架的规格", selectOnSale);
        
         textsss = selectOnSale[0].itemAttrValue;
      }
      console.log('this.show_text ',textsss );
      this.show_text = textsss
      this.show_text1 = textsss1
      this.gift_details = list;
      this.getaddress(1);
    },
    compare(key) {
      //排序
      return function (obj1, obj2) {
        if (Number(obj1[key]) < Number(obj2[key])) {
          return 1;
        } else if (obj1[key] === obj2[key]) {
          return 0;
        } else {
          return -1;
        }
      };
    },
    bindchanrfgg(a, b, c) {
      if (this.gift_details.spuList[a].subGoodss[b].indexx == c) {
        // this.gift_details.spuList[a].subGoodss[b].indexx = null;
        // this.$set(this.gift_details.spuList[a].subGoodss[b], "indexx", null);
      } else {
        this.$set(this.gift_details.spuList[a].subGoodss[b], "indexx", c);
      }
      console.log(this.gift_details);
      // this.setData({
      // 	lb_detail: lb_detail
      // }, () => {
      // 	console.log(lb_detail)
      // });
    },
    bindchanrgegg(a, b, c) {
      console.log(a, b, c);
      this.gift_details.spuList[a].attr[b].index = c;

      this.bindshow(a);
      // var xz_list=this.gift_details.spuList[a].attr[b].list[c].list
      // xz_list.forEach((item)=>{
      //   this.gift_details.spuList[a].attr.forEach((item1)=>{
      //     console.log(item1)
      //     item1.list.forEach((item2)=>{
      //       console.log(item.skuId)
      //       console.log(item2)
      //       item2.show=false
      //       item2.list.forEach((item3)=>{
      //         if(item.skuId==item3.skuId){
      //           item2.show=true
      //         }
      //       })
      //     })
      //   })
      // })
      // console.log(this.gift_details.spuList[a].attr)
      // var key = this.gift_details.spuList[a].attr[b].attrId
      // var items = this.selectedItem
      // var value =this.gift_details.spuList[a].attr[b].list[c].list
      // items[key] = value;
    },
    binddhs(){
       var list = this.gift_details.spuList;
      console.log(this.gift_details);
      console.log(this.gift_details.spuList);
      var address = this.show_address ? this.show_address : "";
      var ids = "";
      var f_ids = "";
      list.forEach((item,index) => {
        console.log(item);
        if (item.show_skuid) {
          console.log(item.show_skuid)
          ids += item.show_skuid + "_"+ this.gift_details.spuNoList[index] +','; // item.itemSkus.forEach((item1) => {
        }
      });
      ids = ids.substring(0, ids.length - 1);
       var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      var data = {
        skuNos: ids
      };
      this.$server.skulimit(data, headers).then((res) => {
        var list = res.data.default
        var lists = list.filter(val=>!val.result)
        var text = ''
        lists.forEach((item)=>{
          text+=item.name+','
        })
          console.log('校验sku购买限制',res)
        if(text){
          this.$confirm(lists[0].name+'每人'+lists[0].limitDay+'天内限购'+lists[0].limitNum+'件', "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              
            })
        }else{
          this.bindxg()
        }
      })
    },
    bindxg() {
      // this.bindxg()
      // return
      if (this.cart_show) {
        console.log(this.$store.state.cart_list);
        console.log(this.gift_details);
        var cart_list = localStorage.getItem("cart_list");
        var list = cart_list ? JSON.parse(cart_list) : [];
        var detail = this.gift_details;
        detail.num = 1;
        if (list.length > 0) {
          var number = 0;
          // list.forEach((item)=>{
          //   if(item.festivalPackage.id==detail.festivalPackage.id){
          //     // item.num+=1
          //     // console.log(item.num)
          //     this.$message({
          //       message: '已加入购物车',
          //       type: "error",
          //     });
          //     number+=1
          //   }
          // })
          if (number == 0) {
            var yf_price = ''
            var feedetail = this.feedetail
            var gift_details = this.gift_details
            if((feedetail && feedetail.isall == 2) ||(feedetail &&feedetail.isall == 1 &&gift_details.festivalPackage.standardPrice / 100 >=feedetail.orderfee)){
                yf_price=''
            }else{
              yf_price = '购满'+feedetail.orderfee+'包邮，否则加收'+feedetail.postfees+'运费'
            }
            detail.yf_price = feedetail.orderfee!=undefined?yf_price:'';
            console.log(yf_price)
            detail.festivalid = this.user.festival.id;
            list.push(detail);

            localStorage.setItem("cart_list", JSON.stringify(list));
          } else {
            localStorage.setItem("cart_list", JSON.stringify(list));
          }
        } else {
            var yf_price = ''
            var feedetail = this.feedetail
            var gift_details = this.gift_details
            if((feedetail && feedetail.isall == 2) ||(feedetail &&feedetail.isall == 1 &&gift_details.festivalPackage.standardPrice / 100 >=feedetail.orderfee)){
                yf_price=''
            }else{
               yf_price = '购满'+feedetail.orderfee+'包邮，否则加收'+feedetail.postfees+'运费'
            }
            detail.yf_price = yf_price;
            console.log(yf_price)
          detail.festivalid = this.user.festival.id;
          list.push(detail);
          localStorage.setItem("cart_list", JSON.stringify(list));
        }
        this.$message({
          message: "加入成功",
          type: "success",
        });
        this.tpVisibless = false;
        console.log(this.gift_details.festivalPackage.festival.name+'+'+this.gift_details.festivalPackage.name)
        this.webStatistics.trackEvent('joinCart',this.gift_details.festivalPackage.festival.name+'+'+this.gift_details.festivalPackage.name)
      } else {
        sessionStorage.setItem(
          "gift_details",
          JSON.stringify(this.gift_details)
        );
        this.$router.push({ path: "/address" });
      }
      localStorage.setItem("show_address", JSON.stringify(this.show_address));
    },
    binddh(e) {
      this.cart_show = false;
      this.tpVisibless = true;
      //   this.$router.push({ path: "/address", query: { id: this.gift_id } });
    },
    price_gsh(e) {
      return (e / 100).toFixed(2);
    },
    ///////////////////返回顶部
    handleScroll() {
      var doc = document.documentElement;
      this.scrollTop = doc.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      var doc = document.documentElement;
      $(doc).animate(
        {
          scrollTop: 0,
        },
        500
      );
    },
    //////////////////////
    distinct(arr, key) {
      var newobj = {},
        newArr = [];
      for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (!newobj[item[key]]) {
          newobj[item[key]] = newArr.push(item);
        }
      }
      return newArr;
    },
    gift_detail() {
      this.loading = true;
      this.detailVisible = true;
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      var data = {
        festivalPackageUid: this.gift_id,
        festivalUid:this.user.festival.uid
      };
      this.$server.getFestivalPackage(data, headers).then((res) => {
        console.log("礼包详情11", res);
        this.loading = false;
        if (res.code == 0) {
          /////规格
          var listt = res.data;
          // let itemSkuBanned = listt.festivalPackage.itemSkuBanned;
          // itemSkuBanned = itemSkuBanned ? itemSkuBanned.split(",") : [];
          let itemSkuEnableds = listt.festivalPackage.itemSkuEnableds
          listt.spuList.forEach((datas) => {
            console.log(datas);
            //筛选可用sku
            let canUseSkus = datas.itemSkus.filter(
              (val) => itemSkuEnableds.includes(String(val.id))
            );
             //筛选禁用sku
            let itemSkuBanned = datas.itemSkus.filter(
              (val) => !itemSkuEnableds.includes(String(val.id))
            );
            console.log('筛选可用sku',canUseSkus)
            console.log('筛选禁用sku',itemSkuBanned)
            //设置默认选中skuId
            let defaultSkuId = canUseSkus[0] ? canUseSkus[0].id : "";
            datas.itemDetail.attrJson = datas.itemDetail.attrJson
              ? JSON.parse(datas.itemDetail.attrJson)
              : [];
            datas.attr = datas.itemDetail.attrJson;
            datas.attr.forEach((item) => {
              item.index = 0;
              if (item.options) {
                console.log("itemSkuBanned :>> ", itemSkuBanned);
                item.options.forEach((item1, index) => {
                  //判断规格项是否禁用
                  let disabledArray = item1.sku_ids.map((val) =>
                    itemSkuEnableds.find(vl=>vl==val)==undefined
                  );
                  item1.sku_ids = item1.sku_ids.filter(
                    (val) => itemSkuEnableds.includes(Number(val))
                  );
                  item1.isDisabled = disabledArray.includes(true); //规格项是否包含已禁用skuId
                  // item1.sku_ids.forEach((skuId) => {
                  //   if (skuId == defaultSkuId) {
                  //     item.index = index;
                  //   }
                  // });
                });
                //过滤已禁用规格项
                item.options = item.options.filter((option) => {
                  option.sku_ids.forEach((skuId, index) => {
                    if (skuId == defaultSkuId) {
                      option.index = index;
                    }
                  });
                  return option.sku_ids.length !== 0;
                });
              }
            });
          });
          var num = 0;
          listt.spuNoList.forEach((iteme) => {
            num += iteme;
          });
          this.packageCount =res.data.festivalPackage.packageCount
          this.all_num = num;
          this.gift_details = listt;
          this.bindshow();
          console.log("排序后", listt.spuList);
          this.sp_details = listt.spuList[0];
          console.log(this.gift_details);
        } else {
          if(res.code!=-403){
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          
        }
      });
      setTimeout(() => {
        this.loading = false;
      }, 10000);
    },
    compare(key) {
      return function (obj1, obj2) {
        if (Number(obj1[key]) < Number(obj2[key])) {
          return 1;
        } else if (obj1[key] === obj2[key]) {
          return 0;
        } else {
          return -1;
        }
      };
    },
    onSlideChangeEnd(e) {
      //图片完成轮播后
      var width = 18 * 100 - 6 * 100;
      if (this.left < width) {
        this.left += 100;
        //					$('.box').scrollLeft(this.left,0);
        var left = "transform: translate(-" + this.left + "px,0)";
        this.yidong = left;
      }
      //				console.log(width,left)
    },
    onSlideChangeEnd1(e) {
      //图片完成轮播后
      if (this.left > 0) {
        this.left -= 100;
        var left = "transform: translate(-" + this.left + "px,0)";
        this.yidong = left;
        //					$('.box').scrollLeft(this.left,0);
      }
    },

    bindycs() {},
    //////////////////////////////////////////////
    //鼠标进入小图时事件，显示对应的中图
    enterLi(e) {
      //e是对应的下标
      // this.active_img=this.list[e].img_url
      //	            this.mdImgUrl=this.list[e].md;
      //	            this.lgImgUrl=this.list[e].lg;
      console.log(e);
      this.d_index = e;
      this.sp_details = this.gift_details.spuList[e];
    },

    //点击左右按钮事件ul的li移动,每个li宽74px，ul宽370显示5个li
    next() {
      //向左移动-
      console.log(this.ulIndex);
      if (this.ulIndex > -(this.gift_details.spuList.length - 4)) {
        this.ulIndex--;
        this.marginLeft = this.ulIndex * 278;
      }
    },
    prev() {
      //向右移动++
      console.log(this.ulIndex);
      if (this.ulIndex < 0) {
        this.ulIndex++;
        this.marginLeft = this.ulIndex * 278;
      }
    },

    //鼠标进入和离开
    enter() {
      this.isShow = true;
    },
    leave() {
      this.isShow = false;
    },
    //遮罩层放大镜
    marks(e) {
      //console.log(e.offsetX,e.offsetY)   //鼠标移入时的位置·
      var marksWidth = 200; //marks的宽
      var marksHeight = 200; //marks的高

      this.left = e.offsetX - marksWidth / 2;
      this.top = e.offsetY - marksHeight / 2;
      //console.log(this.left,this.top)
      if (this.left < 0) {
        this.left = 0;
      } else if (this.left > 240) {
        this.left = 240;
      }
      if (this.top < 0) {
        this.top = 0;
      } else if (this.top > 240) {
        this.top = 240;
      }
      //console.log(this.left,this.top)

      //中图片div宽高450，大图片div宽高800
      this.leftLgImg = (-this.left * 800) / 450;
      this.topLgImg = (-this.top * 800) / 450;
    },
    binddq_kcs() {
      ////查询地区有无库存////
      var list = this.gift_details.spuList;
      var address = this.show_address ? this.show_address : "";
      // var addressDetail = address.province+address.city+address.district+(address.town?address.town:'')+(address.detail ? address.detail : (address.street ? address.street : ''))
      var dq_data = {
        spuId: list[0].id,
        districtId: address.districtId ? address.districtId : "0",
        townId: address.townId ? address.townId : "0",
        cityId: address.cityId ? address.cityId : "0",
        provinceId: address.provinceId ? address.provinceId : "0",
        // addressDetail:addressDetail
      };
      var header = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.getSpu(dq_data, header).then((res) => {
        console.log("查运费", res);
        if (res.code == 0) {
          this.feedetail = res.data.supplier;
        }
      }); ////////
    },
    //////////////////////////////////////////////////////
    qr_address() {
      var address = this.show_address ? this.show_address : "";
      var list = this.gift_details;
      var spuIds = "";
      var skuNames = "";
      list.spuList.forEach((item) => {
        spuIds += item.id + ",";
        skuNames += item.name + ",";
      });
      spuIds = spuIds.substring(0, spuIds.length - 1);
      skuNames = skuNames.substring(0, skuNames.length - 1);
      var data = {
        cityId: address.cityId,
        provinceId: address.provinceId,
        spuIds: spuIds,
        skuNames: skuNames,
      };
      var header = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.verifyItemRegion(data, header).then((res) => {
        //console.log(res);

        if (res.code == 0) {
          this.address_show = true;
        } else {
          this.address_show = false;
        }
      });
    },
    binddq_kc() {
      ////查询地区有无库存////
      var list = this.gift_details.spuList;
      console.log(this.gift_details);
      console.log(this.gift_details.spuList);
      var address = this.show_address ? this.show_address : "";
      var ids = "";
      var f_ids = "";
      list.forEach((item) => {
        console.log(item);
        if (item.show_skuid) {
          ids += item.show_skuid + ","; // item.itemSkus.forEach((item1) => {
        }else{
          ids += item.itemSkus[0].id + ",";
        }
      });
      ids = ids.substring(0, ids.length - 1);
      //console.log(ids);
      var dq_data = {
        skuIds: ids,
        skuPurchaseNos: this.gift_details.spuNoList.toString(),
        //  userAddressUid: this.data.show_address.uid,
        districtId: address.districtId ? address.districtId : "0",
        townId: address.townId ? address.townId : "0",
        cityId: address.cityId ? address.cityId : "0",
        provinceId: address.provinceId ? address.provinceId : "0",
      };
      var header = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: this.user.token,
      };
      this.$server.verifyItemStock(dq_data, header).then((res) => {
        console.log("查询地区有无库存", res);

        if (res.code == 0) {
          var dq_kc_text = "";
          res.data.default.forEach((item) => {
            list.forEach((item1) => {
              console.log(item);
              if (item.stockStae == 0 && item1.show_skuid == item.skuId) {
                dq_kc_text += item1.name + ",";
              }
            });
          });
          console.log("dq_kc_text", dq_kc_text);
          this.dq_kc_text = dq_kc_text; // order_lsit:list
        }
      }); ////////
    },
  },
};
</script>

<style lang="scss" scoped>
.letter{
     letter-spacing: 2px
}
.letters{
     letter-spacing: 30px
}

.sale_price {
  background: #f0f0f0;
  height: 48px;
}
.no_show {
  color: #999999 !important;
}
.gg_box {
  border-bottom: 1px solid #e4e5ed;
  padding: 20px 0;
}
.gg_box:nth-child(1) {
  padding-top: 0 !important;
}
.gbox {
  display: flex;
  padding-top: 24px;
  .g_active {
    color: #f3a251 !important;
    border-color: #f3a251 !important;
  }
  .titles {
    display: inline-block;
    min-width: 60px;
    margin-right: 10px;
  }
  .g_li {
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;
    color: #5b5d66;
    border: 1px solid #cccccc;
    padding: 1px 8px;
  }
}
.d_index {
  border: 2px solid #f3a251 !important;
}
.aniu {
  display: flex;
  align-items: center;
  margin-top: 80px;
}
.ljdhs {
  height: 50px;
  width: 186px;
  display: inline-block;
  line-height: 50px;
  cursor: pointer;
  margin-left: 10px;
  text-align: center;
  color: #f3a251;
  border: 1px solid;
  background: #fffaf6;
}
.ljdh {
  height: 50px;
  width: 186px;
  cursor: pointer;
  background: #f3a251;
  display: inline-block;
  line-height: 50px;
  text-align: center;
  color: white;
}
.fanwei1 {
  -webkit-line-clamp: 99 !important;
}
.fanwei {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 40px;
}
.zksqs {
  position: absolute;
  top: 0px;
  right: 0px;
  color: #289bff;
  cursor: pointer;
}
.sp {
  min-height: 500px;
  border-top: 1px solid #e4e5ed;
  padding: 20px 0;
  padding-top: 0;
  .page-up {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #b7a5a4;
    height: 40px;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    width: 40px;
    img {
      height: 20px;
      width: 20px;
    }
  }
  .detail_bottom {
    justify-content: space-between;
    display: flex;
    width: 1200px;
    margin: 20px auto;
    .d_b_left {
      width: 969px;
      width: 100%;
      h5 {
        height: 40px;
        background: #f7f7f7;
        line-height: 40px;
        padding-left: 24px;
        text-align: left;
        font-size: 16px;
      }
      .fwb {
        min-height: 400px;
        padding-top: 16px;
        width: 750px;
        text-align: left;
        p {
          width: 100%;
          //   line-height: 0 !important;
          img {
            width: 1260px !important;
            height: auto !important;
            float: left;
          }
        }
      }
    }
    .d_b_right {
      width: 210px;
      border: 1px solid #e6e6e6;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 26px;
      h5 {
        width: 100%;
        height: 40px;
        background: #fff7f4;
        line-height: 40px;
        padding-left: 24px;
        text-align: left;
        font-size: 16px;
        color: #fb662d;
      }
      .d_b_r_box {
        width: 162px;
        margin-top: 26px;
        img {
          width: 100%;
          height: 162px;
        }
        h6 {
          font-size: 14px;
          margin-top: 12px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          -webkit-line-break: auto;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .detailss {
    padding-top: 20px;
    .sp_right {
      padding-top: 5px;
      padding-left: 20px;
      width: 100%;
      h5 {
        text-align: left;
        margin-bottom: 20px;
        font-size: 16px;
      }
      .sp_r_bottom {
        color: #999999;
        padding: 15px;
        text-align: left;
        .guigui {
          letter-spacing: 0px !important;
        }
        .gg_active {
          color: #ff5c4d !important;
          border-color: #ff5c4d !important;
        }
        .jrlb {
          background: #ff5c4d;
          height: 46px;
          width: 160px;
          cursor: pointer;
          color: white;
          border-radius: 4px;
          font-weight: 600;
          text-align: center;
          line-height: 46px;
          margin-top: 50px;
          margin-left: 87px;
        }
        .number {
          align-items: center;
          display: flex;
          input {
            height: 25px;
            width: 40px;
            border: 1px solid #e6e6e6;
            border-left: 0;
            border-right: 0;
            text-align: center;
          }
          span {
            display: inline-block;
            height: 25px;
            width: 25px;
            line-height: 25px;
            text-align: center;
            border: 1px solid #e6e6e6;
          }
        }
        .guige {
          /*margin-left:24px;*/

          span {
            display: inline-block;
            cursor: pointer;
            padding: 5px 10px;
            border: 1px solid #e6e6e6;
            font-size: 12px;
            font-family: MicrosoftYaHeiUI;
            color: rgba(26, 26, 26, 1);
            margin-right: 16px;
            margin-bottom: 5px;
          }
        }
      }
      .sp_r_price {
        width: 739px;
        min-height: 88px;
        background: #f0f0f0;
        text-align: left;
        color: #999999;
        padding: 10px 15px;
        .pptt {
          height: 28px;
          min-width: 72px;
          padding: 0 10px;
          background: white;
          line-height: 28px;
          display: inline-block;
          font-size: 12px;
          color: #1a1a1a;
          text-align: center;
        }
        div {
          display: flex;
          /*align-items: center;*/
          .span {
            display: inline-block;
            width: 88px;
          }
        }
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
    }
    .content > .product {
      display: flex;
      justify-content: space-between;
    }
    /* 左侧大小图样式 */
    .productLeft {
      width: 450px;
      position: relative;
    }
    /* 左侧中图 */
    .mdImg,
    .mdImg > img {
      width: 440px;
      height: 440px;
    }
    /*遮罩层superMarks */
    .superMarks {
      width: 440px;
      height: 440px;
      border: 1px solid #eeeeee;
      background-color: rgba(220, 220, 220, 0);
      position: absolute;
      top: 0px;
      left: 0px;
    }
    /* 遮罩层 */
    .marks {
      width: 200px;
      height: 200px;
      position: absolute;
      background-color: rgba(220, 220, 220, 0.5);
      /*top:0px;  //内联设置了动态的top，left
		        left:0px;*/
    }
    /* 左侧小图 */
    .smImg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
    }
    .smImgUl {
      overflow: hidden;
      // width: 370px;
    }
    .smImg ul {
      display: flex;
      min-width: 1136px;
      margin: 0;
      padding: 10px;
    }
    .smImg ul > li {
      padding: 0 3px;
      margin-right: 57px;
      width: 220px;
    }
    .smImg ul > li p {
      text-align: center;
      margin-top: 16px;
      color: #0a1132;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .smImg img {
      height: 220px;
      width: 220px;
      cursor: pointer;
      margin-top: 16px;
      border: 2px solid white;
    }

    /* 左侧隐藏大图 */
    .lgImg {
      width: 440px;
      height: 440px;
      overflow: hidden;
      position: absolute;
      top: 0px;
      left: 440px;
      border: 2px solid #aaa;
      background-color: #fff;
      z-index: 999;
    }
    .lgImg img {
      width: 880px;
      height: 880px;
      position: absolute;
      /*top:100px;
		        left:100px;*/
    }
    /* product右侧 */
    .productRight {
      width: 700px;
    }
    /* 左右按钮 */
    .button-prev,
    .button-next {
      width: 35px;
      height: 35px;
      line-height: 30px;
      /*border: 1px solid #ddd;*/
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
    }
    // .button-prev:hover,
    // .button-next:hover {
    // 	/*background-color: #eee;*/
    // }
    .button-prev > img,
    .button-next > img {
      width: 20px;
      height: 20px;
    }
  }
  .spnav {
    border-bottom: 2px solid #5b463c;
    .nav_box {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      display: flex;
      .searh {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 243px;
        height: 32px;
        background: white;
        border-radius: 50px;
        padding: 0 16px;
        position: absolute;
        right: 120px;
        top: -78px;
        span {
          font-size: 14px;
          color: #ff5c4d;
        }
        input {
          border: none;
          outline: none;
          width: 154px;
        }
        img {
          margin-top: 2px;
        }
      }
      .nav_left {
        width: 190px;
        height: 33px;
        background: #5b463c;
        line-height: 33px;
        color: white;
        position: relative;
        .caidan_1 {
          height: 350px !important;
          padding: 10px 0;
        }
        .caidan {
          overflow: auto;
          position: absolute;
          top: 33px;
          height: 0px;
          width: 100%;
          z-index: 999;
          background: white;
          font-size: 14px;
          font-family: MicrosoftYaHeiUI;
          color: rgba(26, 26, 26, 1);
          transition: all 0.3s;
          box-shadow: 0px 0px 5px #666666;
          .caidan1 {
            width: 99%;
          }
          .caidan1s {
            color: #ff5c4d;
          }
        }
        .caidan2_1 {
          width: 500px !important;
          border: 1px solid #666666;
        }
        .caidan2 {
          transition: all 0.3s;
          box-shadow: 0px 0px 10px #666666;
          height: 350px;
          width: 0px;
          background: white;
          position: absolute;
          left: 190px;
          top: 32px;
          z-index: 99;
          overflow: auto;
          .cd_box:hover .ssssd {
            color: #ff5c4d;
          }
          .cd_box {
            color: #1a1a1a;
            text-align: left;
            display: flex;
            div {
              max-width: 350px;
              padding-left: 10px;
              span {
                display: inline-block;
                border-left: 1px solid #e0e0e0;
                height: 16px;
                color: #808080;
                margin-left: 10px;
                padding-left: 10px;
                line-height: 16px;
                cursor: pointer;
              }
              span:hover {
                color: #ff5c4d;
              }
            }
          }
        }
      }
      .swi {
        width: 980px;
        height: 33px;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        .s_box {
          transition: all 0.5s;
          /*display: -webkit-box;
						overflow-x: scroll;
						overflow-y: hidden;
						overflow-x: hidden;
						-webkit-overflow-scrolling: touch;*/
          align-items: center;
          /*margin-top:48px;*/
          display: flex;
          height: 100%;
          span {
            cursor: pointer;
            display: inline-block;
            width: 60px;
            margin-right: 40px;
            font-weight: 600;
          }
          .s_active {
            color: #ff5c4d;
          }
        }
        .you {
          position: absolute;
          right: 55px;
          top: 10px;
        }
        .zuo {
          position: absolute;
          right: 20px;
          top: 10px;
        }
      }
    }
  }
}
</style>